import { useIntl } from 'react-intl';
export const THOUSAND = 1000;
export const MILLON = 1000000;
export const useShortNumber = (num) => {
    const { locale } = useIntl();
    let shortNumber = '';
    if (num >= MILLON) {
        shortNumber = (num / MILLON).toFixed(1) + 'M';
    }
    else if (num >= THOUSAND && num < THOUSAND + 50) {
        shortNumber = '1K';
    }
    else if (num >= THOUSAND + 50) {
        shortNumber = (num / THOUSAND).toFixed(1) + 'K';
    }
    else {
        shortNumber = num.toString();
    }
    if (locale === 'de') {
        shortNumber = shortNumber.replace('.', ',');
    }
    return { shortNumber };
};
//# sourceMappingURL=use-short-number.js.map